import { FC, SVGAttributes } from 'react';

const CheckSolid: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12.5C22 18.0228 17.5228 22.5 12 22.5C6.47715 22.5 2 18.0228 2 12.5C2 6.97715 6.47715 2.5 12 2.5C17.5228 2.5 22 6.97715 22 12.5ZM17.0767 7.68311C17.5279 8.00161 17.6355 8.62557 17.317 9.07677L11.5115 17.3012C11.0276 17.9868 10.0189 18.0102 9.50362 17.3478L6.21069 13.114C5.87162 12.6781 5.95016 12.0498 6.38611 11.7107C6.82205 11.3717 7.45033 11.4502 7.7894 11.8861L10.4611 15.3212L15.6831 7.9234C16.0016 7.4722 16.6255 7.36462 17.0767 7.68311Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CheckSolid;
